























import { Component, Vue } from "vue-property-decorator"
import EditAdminUser from "@/components/EditAdminUser.vue"
import { AdminUser } from "types/adminUser"

@Component({
  components: { EditAdminUser },
})
export default class ProfileMenu extends Vue {
  private dialog = false

  private existThumbnail(): boolean {
    const adminUser = this.$store.state.adminUser
    return (
      adminUser &&
      adminUser.thumbnail &&
      adminUser.thumbnail.filename !== "" &&
      adminUser.thumbnail.url !== ""
    )
  }

  private updateAdminUser(adminUser: AdminUser["data"]) {
    this.$store.dispatch("adminUser/updateAdminUser", adminUser)

    this.close()
  }

  private open() {
    const editAdminUser = this.$refs.editAdminUser as InstanceType<
      typeof EditAdminUser
    >
    editAdminUser.open()
  }

  private close() {
    this.dialog = false
  }
}
